import { Children, cloneElement } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import * as recharts from 'recharts'

import { LockIcon } from '@h2/components/icons/lock'
import { WHITE, PB90T, SLB, SLB80T } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Skeleton } from '@h2/components/loading/skeleton'

import { AnchorButton } from '../anchorButton'

const { Area, AreaChart, ResponsiveContainer } = recharts
const Wrap = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: ${({ width }) => width};
  background-color: ${WHITE};
  flex-grow: 1;
  padding: 10px;
  border: solid ${PB90T} 1px;
  border-radius: 4px;
  position: relative;
`
const StyledIcon = styled(LockIcon)`
  position: absolute;
  top: 3px;
  right: 3px;
`
const StyledHeading = styled(Heading)`
  color: ${({ locked, color }) => (locked === 'true' ? PB90T : color)};
`
const OverviewItemHeading = ({ children, ...props }) => (
  <StyledHeading align="center" mb="3px" level="2" {...props}>
    {children}
  </StyledHeading>
)
const OverviewItemText = ({ children, ...props }) => (
  <Text size="small" align="center" margin="0" {...props}>
    {children}
  </Text>
)
const OverviewItemButton = ({ children, ...props }) => (
  <AnchorButton {...props}>{children}</AnchorButton>
)
const OverviewItemChart = ({ data = [], dot = { r: 0.75 }, strokeWidth = 0.75 }) => (
  <ResponsiveContainer>
    <AreaChart data={data}>
      <Area
        dataKey="value"
        stroke={SLB}
        fill={SLB80T}
        strokeWidth={strokeWidth}
        dot={dot}
      />
    </AreaChart>
  </ResponsiveContainer>
)
const OverviewItem = ({ children, isFetching, width = '', locked = 'false' }) => {
  if (isFetching) {
    return <Skeleton display="block" height="100px" width={width} />
  }

  return (
    <Wrap width={width}>
      {locked === 'true' && <StyledIcon height="28px" width="28px" />}
      {Children.map(children, child => cloneElement(child, { locked }))}
    </Wrap>
  )
}

OverviewItem.propTypes = {
  width: PropTypes.string,
  locked: PropTypes.bool,
  isFetching: PropTypes.bool
}

OverviewItem.Heading = OverviewItemHeading
OverviewItem.Text = OverviewItemText
OverviewItem.Button = OverviewItemButton
OverviewItem.Chart = OverviewItemChart

export { OverviewItem }
